<template>
  <div>
    <div class="main-title">收支项目管理</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add">新增收支项目</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索项目名称"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:220px"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="item_type_name"
          label="类型"
          width="70">
        </el-table-column>
        <el-table-column
          prop="item_name"
          label="项目名称"
          width="200">
        </el-table-column>
        <el-table-column
          prop="order_no"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" v-if="scope.row.is_del === '0'" @click="invalid(scope.row)" style="color:#f56c6c;">停用</el-button>
            <el-button type="text" v-else @click="valid(scope.row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增收支项目 -->
    <el-dialog :title="addForm.id > 0 ? '修改收支项目' : '新增收支项目'" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="类型">
          <el-select v-model="addForm.item_type">
            <el-option label="收入" value="1"></el-option>
            <el-option label="支出" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="item_name">
          <el-input v-model="addForm.item_name"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="order_no">
          <el-input v-model.number="addForm.order_no"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'fin_item_list',
      pageSize: 0,
      searchForm: {
        query: ''
      },
      addForm: {
        id: 0,
        item_name: '',
        item_type: '1',
        order_no: 0
      },
      addFormRules: {
        item_name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        order_no: [
          { required: true, message: '请输入序号', trigger: 'blur' }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false
    }
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.is_del === '1') {
        return 'row-red'
      } else {
        return ''
      }
    },
    add () {
      this.addForm = {
        id: 0,
        item_name: '',
        item_type: '1',
        order_no: 0
      }
      this.addFormVisible = true
    },
    edit (row) {
      this.addForm = {
        id: row.id,
        item_name: row.item_name,
        item_type: row.item_type,
        order_no: row.order_no
      }
      this.addFormVisible = true
    },
    addFormCommit () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true
          let url = '/dbapi/fin_item_insert'
          if (this.addForm.id > 0) {
            url = '/dbapi/fin_item_update'
          }
          this.$http.post(url, this.addForm).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    invalid (row) {
      this.$confirm('确定要停用这个项目吗？', '提示', {
        confirmButtonText: '确定停用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fin_item_del', {
          id: row.id,
          is_del: '1'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    valid (row) {
      this.$confirm('确定要启用这个项目吗？', '提示', {
        confirmButtonText: '确定启用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fin_item_del', {
          id: row.id,
          is_del: '0'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/finance/Item.vue